import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";

class AlertDismissable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    return (
      <div style={{ display: "inline-block" }}>
        <Button bsStyle="danger" onClick={this.handleShow}>
          CANCEL
        </Button>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Cancel Runsheet</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Cancelling this runsheet will cause any unsaved data to be lost
            </p>
            <p>Are you sure you want to cancel?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="danger"
              className="pull-left"
              onClick={this.props.onCancel}
            >
              Yes
            </Button>
            <Button onClick={this.handleClose}>No</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
AlertDismissable.propTypes = {
  onCancel: PropTypes.func.isRequired
};

export default AlertDismissable;



// WEBPACK FOOTER //
// ./src/components/runsheets/RunsheetControllerCancel.js